let Api = {
	// 合格证
	"CERTIFICATEINFO_FINDPAGELIST": "/quality/w/CertificateInfo/findPageList", //分页查询出证记录列表
	"CERTIFICATEINFO_FINDPAGESCANRECODERLIST": "/quality/w/CertificateInfo/findPageScanRecoderList", //分页查询扫码列表
	"CERTIFICATEINFO_SAVEORUPDATE": "/quality/w/CertificateInfo/saveOrUpdate", //新增保存 - 为pdf文件
	"ENTPAUTH_GETDETAIL": "/system/w/merchantAuth/getDetail", //查询认证信息
	"W_EVALUATION_LABELPAGE": "/quality/w/evaluation/labelPage", //查询申请标签列表
	"W_EVALUATION_FINDPAGELIST": "/quality/w/evaluation/findPageList", //评价项目管理列表查询
	"W_EVALUATION_SAVEAPPLICATIONLABEL": "/quality/w/evaluation/saveApplicationLabel", //申请评价标签
	"N_EVALUATION_GEOPRO_SCANLABELINFO": "/quality/n/geoPro/scanLabelInfo", //数字品质 - 标签/扫描查询
	"ENTPBASEMAGE_FINDPAGELIST": "/difam/w/entpBaseMage/findDistList", //基地列表
	"ENTPBASEMAGE_FINDINFO": "/difam/w/entpBaseMage/findInfo", //基地详情
	"TRADE_W_COMMSALECATG_PAGE": "/b2b/w/commSaleCatg/findPage", //获取商品销售分类分页列表
	"TRADE_W_COMMSALECATG_SAVEORUPDATE": "/b2b/w/commSaleCatg/saveOrUpdate", //新增/修改商品销售分类
	"TRADE_W_COMMSALECATG_DELETE": "/b2b/w/commSaleCatg/delete", //删除商品销售分类
	"SYSTEMCONFIG_GETWEBBASEPIC": "/b2b/w/systemConfig/getWebBasePic", //站点配置图片详情
	"SYSTEMCONFIG_WEBBASEPICSAVE": "/b2b/w/systemConfig/webBasePicSave", //站点配置图片保存
	"SYSTEMCONFIG_GETWEBBASESYS": "/b2b/w/systemConfig/getWebBaseSys", //站点配置信息详情
	"SYSTEMCONFIG_WEBBASESYSSAVE": "/b2b/w/systemConfig/WebBaseSysSave", //站点配置信息保存
}
module.exports = Api